import { Link, Outlet } from 'react-router-dom';

export function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="brand">Partikampen</Link>
        <nav>
          <Link to="/valet-2026">Valet 2026</Link>
          <Link to="/privacy-policy">Integritet</Link>
          <Link to="/terms">Villkor</Link>
        </nav>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="app-footer">
        <p>
          Distriktsdata: <a href="https://www.val.se" target="_blank" rel="noreferrer">Valmyndigheten</a>.{' '}
          Ej anslutet till något politiskt parti.
        </p>
        <p>
          <Link to="/privacy-policy">Integritetspolicy</Link> · <Link to="/terms">Användarvillkor</Link> · <a href="mailto:kontakt@partikampen.se">kontakt@partikampen.se</a>
        </p>
      </footer>
    </div>
  );
}
